import { render, staticRenderFns } from "./Suppiler.vue?vue&type=template&id=8e25db76&scoped=true&"
import script from "./Suppiler.vue?vue&type=script&lang=js&"
export * from "./Suppiler.vue?vue&type=script&lang=js&"
import style0 from "./Suppiler.vue?vue&type=style&index=0&id=8e25db76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e25db76",
  null
  
)

export default component.exports